<template>
  <div>
    <top></top>
    <div class="container">
      <div class="left">
        <div class="imgdiv">
          <img src="@/assets/touxiang.png" />
        </div>
        <h3>{{username3}}</h3>
        <hr
          style="background: #E1E8EC;width:160px;margin-left: auto;margin-right: auto;margin:0 auto 30px auto;"
        />
        <connomtab :class="{'applyrecord':isnowpage}"></connomtab>
      </div>
      <div class="right">
        <h2 class="page-title">
          <span></span>详情页面
          <div @click="back" class="right back cursor">返回</div>
        </h2>
        <div class="box2">
          <form class="layui-form layui-form1">
            <div class="layui-form-item">
              <div class="layui-inline" style="margin-left: 41px;">
                <label>标段名称</label>
              </div>
            </div>
            <ul class="ul1">
              <li>
                <div class="order-text">订单编号</div>
                <div class="order-number">{{orderOverview[0].orderno}}</div>
              </li>
              <li>
                <div class="order-text">订单金额</div>
                <div class="order-number">{{orderOverview[0].guaranteeFee }}</div>
              </li>
              <li>
                <div class="order-text">订单时间</div>
                <div class="order-number">{{orderOverview[0].createTime}}</div>
              </li>
              <li>
                <div class="order-text">订单状态</div>
                <div v-if="orderOverview[0].status==0" style="color:blue;" class="order-number">未支付</div>
                <div
                  v-else-if="orderOverview[0].status==1"
                  style="color:blue;"
                  class="order-number"
                >待审核</div>
                <div
                  v-else-if="orderOverview[0].status==2"
                  style="color:blue;"
                  class="order-number"
                >待上传</div>
                <div
                  v-else-if="orderOverview[0].status==3"
                  style="color:blue;"
                  class="order-number"
                >已驳回</div>
                <div
                  v-else-if="orderOverview[0].status==5"
                  style="color:blue;"
                  class="order-number"
                >已完成</div>
              </li>
            </ul>
            <div class="layui-form-item">
              <div class="layui-inline" style="margin-left: 41px;">
                <label>标段名称</label>
              </div>
            </div>
          </form>
          <table
            lay-filter="demo"
            lay-data="{id:'idTest'}"
            class="table2"
            border="1"
            cellspacing="1"
            cellpadding="0"
          >
            <thead>
              <tr>
                <th>交易中心</th>
                <!-- <th>项目名称</th>
                <th>标段编号</th>-->

                <th>标段名称/投标登记号</th>
                <th>保函类型</th>
                <th>保证金金额</th>
                <th>投标登记号</th>
                <th>支付方式</th>
                <th>担保机构</th>
                <th>电子保函原件</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div>{{orderOverview[0].tradingPlatformName}}</div>
                </td>
                <!-- <td>
						  <div>
							{{orderOverview[0].blockName}}
						</div>
                </td>-->
                <td>
                  <div>{{orderOverview[0].blockName}}</div>
                </td>
                <td>
                  <div v-if="orderOverview[0].guaranteeType==0">投标保函</div>
                </td>
                <td>
                  <div>{{orderOverview[0].marginAmount == 0 ? "/" : orderOverview[0].marginAmount}}</div>
                </td>
                <td>
                  <div>{{orderOverview[0].registerNumber}}</div>
                </td>
                <td>
                  <!-- <div v-if="orderOverview[0].payMode==4">/</div>
                  <div v-if="orderOverview[0].payMode==2">/</div>
                  <div v-if="orderOverview[0].payMode==1">/</div>-->
                  <div v-if="orderOverview[0].payMode==4">银行转账</div>
                  <div v-if="orderOverview[0].payMode==2">支付宝</div>
                  <div v-if="orderOverview[0].payMode==1">微信</div>
                  <div
                    v-if="orderOverview[0].payMode== null"
                  >{{orderOverview[0].guarantor== 1?"中金支付":"/"}}</div>
                </td>
                <td>
                  <div v-if="orderOverview[0].guarantor==0">甘肃担保</div>
                  <div v-if="orderOverview[0].guarantor==1">瀚华担保</div>
                  <div v-if="orderOverview[0].guarantor==2">兰州银行</div>
                </td>
                <td>
                  <div>
                    <div
                      type="button"
                      class="layui-btn layui-btn-xs"
                      style="width:36px"
                      @click="down"
                    >下载</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import top from "@/components/Head/Head.vue";
import applybaohan from "@/components/apply-baohan/apply-baohan";
import applyrecord from "@/components/apply-record/apply-record";
import connomtab from "@/components/connom_tab/connom_tab";

export default {
  components: {
    top,
    applybaohan,
    applyrecord,
    connomtab,
  },
  name: "baohansystem",
  data() {
    return {
      downPdfUrl: "",
      username3: "",
      isnowpage: true,
      categories: [
        {
          cateid: 0,
          name: "申请电子保函"
        },
        {
          cateid: 1,
          name: "保函申请记录"
        },
        {
          cateid: 2,
          name: "企业信息管理"
        }
      ],
      num: 0,
      cateCurrentIndex: 0,
      heh: Object,
      second: Number,
      yes: false,
      orderOverview: "",
      id: ""
    };
  },
  computed: {},
  beforeCreate() {},
  created() {
    var that = this;
    that.id = that.$route.query.id;
    this.$http.get("/erong/getNickName")
      .then(res => {
        if (res.data.status == 1) {
          this.username3 = res.data.msg;
        } else {
          this.username3 = "公航旅电子交易中心平台用户";
        }
      });
  },
  mounted() {
    var that = this;
    that.$axios
      .get("/getDetails/getDetails/" + that.id, {
        headers: {
          "content-type": "application/json",
          tokenId: that.$store.state.tokenId
        },
        xhrFields: {
          withCredentials: true
        }
      })
      .then(res => {
        console.log(res);
        if (res.data.status == 1) {
          that.orderOverview = res.data.data;
          console.log(res.data.data);

          for (let i = 0; i < res.data.data.length; i++) {
            console.log(res.data.data[i].guaranteeUrl);
            that.downPdfUrl = res.data.data[i].guaranteeUrl;
          }
          console.log(that.downPdfUrl);
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    down() {
      // var queryParams = {
      //   guaranteeUrl: this.downPdfUrl
      // };
      if (this.downPdfUrl != null) {
        var guaranteeUrl = this.downPdfUrl;
        window.open(guaranteeUrl);
      }
      // console.log(this.downPdfUrl);
    },
    back() {
      // this.$router.go(-1);//返回上一层
      window.history.back(-1);
      // window.location.href=document.referrer
    }
  }
};
</script>

<style scoped="scoped" lang="less">
.block-center {
  margin: 0 auto;
}
.container {
  width: 1200px;
  .block-center;
  & > div.left {
    width: 200px;
    background: #ffffff;
    border: 1px solid #e1e8ec;
    .imgdiv {
      width: 100px;
      height: 100px;
      background: #19aecf;
      margin: 50px auto 14px auto;
    }
    h3 {
      font-size: 14px;
      color: #3c4f57;
      letter-spacing: 0;
      text-align: center;
      margin-bottom: 28px;
    }
  }
  & > div.right {
    width: 978px;
    background: #ffffff;
    // border-left:  1px solid #e1e8ec;
    // border-right:  1px solid #e1e8ec;
    border: 1px solid #e1e8ec;
    // border-top: 1px solid #e1e8ec;
  }
}

//当前页面style
.table2 {
  width: 91%;
  margin: 0 auto;
  td {
    div {
      margin: 0 auto;
      display: table;
    }
    border: 1px solid #e1e8ec;
    padding: 12px 8px;
    font-size: 12px;
  }
  th {
    div {
      margin: 0 auto;
      display: table;
    }
    text-align: center;
    border: 1px solid #e1e8ec;
    font-size: 12px;
    padding: 5px 8px;
  }
}
thead {
  background: #fafbfc;
}
.table-flex-head {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #e1e8ec;
  border-bottom: none;
  margin-bottom: 30px;
  height: 40px;
  width: 91%;
  background: #fafbfc;
}
.page-title {
  height: 50px;
  background: #fafbfc;
  // border: 1px solid #E1E8EC;
  border-left: 1px solid #e1e8ec;
  border-right: 1px solid #e1e8ec;
  border-bottom: 1px solid #e1e8ec;
  overflow: hidden;
  line-height: 52px;
  font-size: 16px;
  color: #3c4f57;
  font-weight: bold;
  .back {
    font-size: 14px;
    margin-right: 24px;
  }
  span {
    height: 8px;
    width: 8px;
    display: inline-block;
    border-radius: 50%;
    background: #19aecf;
    margin-top: -2px;
    margin-left: 24px;
    margin-right: 8px;
    vertical-align: middle;
  }
}

.box2 {
  width: 100%;
  background: #ffffff;
  margin-bottom: 20px;
  .ul1 {
    display: table;
    margin: 0 auto;
    overflow: hidden;
    border: 1px solid #e1e8ec;
    border-bottom: none;
    margin-bottom: 30px;
    width: 91%;
    li {
      width: 49.9%;
      height: 44px;
      line-height: 45px;
      float: left;
      border-bottom: 1px solid #e1e8ec;
      overflow: hidden;
      .order-text {
        width: 20%;
        height: 100%;
        float: left;
        text-align: center;
        background: #fafbfc;
        border-right: 1px solid #e1e8ec;
      }
      .order-number {
        width: 79%;
        float: left;
        text-indent: 20px;
      }
    }
    li:nth-child(2n-1) {
      // border-bottom:none;
      border-right: 1px solid #e1e8ec;
    }
  }
}

.layui-input-block {
  margin-left: 0;
}

.layui-form1 {
  margin-top: 30px;

  .layui-inline {
    margin-left: 16px;
  }

  label {
    color: #3c4f57;
    span {
      font-size: 12px;
      color: #ff5555;
    }
  }
}
</style>
